import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable @atlaskit/design-system/no-custom-icons */
import React from 'react';
import Icon from '@atlaskit/icon';
import { fg } from '@atlaskit/platform-feature-flags';
var IconUrlGlyph = function IconUrlGlyph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "15",
    width: "20",
    height: "2",
    rx: "1",
    fill: "currentColor"
  }));
};
export var IconUrl = function IconUrl(props) {
  return fg('platform-custom-icon-migration') ? /*#__PURE__*/React.createElement(IconUrlGlyph, {
    "aria-label": props.label,
    style: {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      width: '24px',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      height: '24px'
    }
  }) :
  /*#__PURE__*/
  // Ignored via go/ees005
  // eslint-disable-next-line react/jsx-props-no-spreading
  React.createElement(Icon, _extends({
    glyph: IconUrlGlyph
  }, props));
};